export function getSuggestionResultLength(suggestionResults) {
  return Object.values(suggestionResults).reduce((accumulator, currentValue) => accumulator + currentValue.length, 0);
}

export function generateLink(suggestionResult, suggestionQuery) {
  return `${suggestionResult.url}?searchQuery=${encodeURIComponent(suggestionQuery)}`;
}
